import IMainCardProps from "@/interfaces/Props/Card/IMainCardProps";
import {
  Card,
  CardContent,
  CardHeader,
  CardProps,
  useTheme,
} from "@mui/material";
import { forwardRef } from "react";

// header style
const headerSX = {
  p: 2.5,
  "& .MuiCardHeader-action": { m: "0px auto", alignSelf: "center" },
};

const MainCard = forwardRef<HTMLDivElement, IMainCardProps & CardProps>(
  (
    {
      border = true,
      boxShadow,
      children,
      isContent = true,
      contentSX = {},
      darkTitle,
      elevation,
      secondary,
      shadow,
      sx,
      headerTitle,
      ...others
    },
    ref
  ) => {
    const theme = useTheme();
    boxShadow = theme.palette.mode === "dark" ? boxShadow || true : boxShadow;

    return (
      <Card
        elevation={elevation || 0}
        ref={ref}
        {...others}
        sx={{
          border: border ? "1px solid" : "none",
          borderRadius: 2,
          borderColor:
            theme.palette.mode === "dark"
              ? theme.palette.divider
              : theme.palette.grey.A700,
          boxShadow:
            boxShadow && (!border || theme.palette.mode === "dark")
              ? shadow || theme.customShadows.z1
              : "inherit",
          ":hover": {
            boxShadow: boxShadow ? shadow || theme.customShadows.z1 : "inherit",
          },
          "& pre": {
            m: 0,
            p: "16px !important",
            fontFamily: theme.typography.fontFamily,
            fontSize: "0.75rem",
          },
          ...sx,
        }}
      >
        {/* card header and action */}
        {!darkTitle && headerTitle && (
          <CardHeader
            sx={headerSX}
            titleTypographyProps={{ variant: "subtitle1" }}
            title={headerTitle}
            action={secondary}
          />
        )}
        {darkTitle && headerTitle && (
          <CardHeader sx={headerSX} title={headerTitle} action={secondary} />
        )}

        {/* card content */}
        {isContent && <CardContent sx={contentSX}>{children}</CardContent>}
        {!isContent && children}
      </Card>
    );
  }
);

export default MainCard;
